import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TrajetService } from 'src/app/core/services/trajet.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-liste-trajets',
  templateUrl: './liste-trajets.component.html',
  styleUrls: ['./liste-trajets.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListeTrajetsComponent implements OnInit {

  colonnesAffichees: string[] = ['actif', 'zoneDepartNom', 'zoneDestinationNom', 'distanceKm', 'actions'];
  sourceDonnees: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  indicateurChargement = true;
  totalEnregistrements: number = 0;

  constructor(
    public trajetZonesService: TrajetService,
    private router: Router,
    private toast: ToastService
  ) {
    this.sourceDonnees = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    this.chargerDonnees();
    this.trajetZonesService.obtenirListeTrajets(0, 500);
  }

  ngAfterViewInit() {
    this.sourceDonnees.paginator = this.paginator;
    this.sourceDonnees.sort = this.sort;
  }

  chargerDonnees() {
    this.trajetZonesService.donnees$.subscribe(
      donnees => {
        this.sourceDonnees.data = donnees;
        this.totalEnregistrements = donnees.length;
        this.indicateurChargement = false;
      },
      erreur => {
        console.error('Erreur lors de la récupération des données', erreur);
        this.indicateurChargement = false;
      }
    );
  }

  appliquerFiltre(event: Event) {
    const valeurFiltre = (event.target as HTMLInputElement).value;
    this.sourceDonnees.filter = valeurFiltre.trim().toLowerCase();
    if (this.sourceDonnees.paginator) {
      this.sourceDonnees.paginator.firstPage();
    }
  }

  ajouterTrajet() {
    this.router.navigate(['/trajet/enregistrer']);
  }

  modifierTrajet(id: number) {
    this.router.navigate(['/trajet/enregistrer', id]);
  }

  supprimerTrajet(trajet: any) {
    this.toast.confirmer(
      `Êtes-vous sûr de vouloir supprimer le trajet "${trajet.zoneDepartNom} → ${trajet.zoneDestinationNom}" ?`,
      'Confirmation de suppression'
    ).subscribe(confirme => {
      if (confirme) {
        this.trajetZonesService.supprimerTrajet(trajet.id).subscribe({
          next: () => {
            this.toast.succes('Trajet supprimé avec succès', 'Succès');
            const donneesMaj = this.sourceDonnees.data.filter(t => t.id !== trajet.id);
            this.sourceDonnees.data = donneesMaj;
            this.totalEnregistrements = donneesMaj.length;
            if (this.paginator) {
              this.paginator.length = this.totalEnregistrements;
              const pageIndex = this.paginator.pageIndex;
              const pageSize = this.paginator.pageSize;
              const nbPages = Math.ceil(this.totalEnregistrements / pageSize);
              if (pageIndex >= nbPages && pageIndex > 0) {
                this.paginator.previousPage();
              }
            }
            this.trajetZonesService.obtenirListeTrajets(0, 500);
          },
          error: (err) => {
            this.toast.erreur(err?.message || 'Erreur lors de la suppression', 'Erreur');
          }
        });
      }
    });
  }

  surBasculerActif(trajet: any, event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const nouvelleValeurActif = checkbox.checked;

    this.trajetZonesService.basculerActifTrajet(trajet.id, nouvelleValeurActif).subscribe({
      next: () => {
        const action = nouvelleValeurActif ? 'activé' : 'désactivé';
        this.toast.succes(`Trajet ${action} avec succès`, 'Succès');
        trajet.actif = nouvelleValeurActif;
      },
      error: (err) => {
        this.toast.erreur(err?.message || 'Modification impossible', 'Erreur');
        checkbox.checked = !nouvelleValeurActif;
        this.trajetZonesService.obtenirListeTrajets(0, 500);
      }
    });
  }
}
